import React from "react";
import { TableContentForCheckrollWeighReport } from '../../../Common/Table/tableContent';
import _ from "lodash"

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const headerLables = this.props.lables;
        const data = _.cloneDeep(this.props.data);
        const rowNames = this.props.rowNames;
        const details = this.props.weighDetails;
        const detailDeductions = this.props.detailDeductions;
        const employeeCount = this.props.employeeCount;

        function roundNumbers(number) {
            return Math.round((number + Number.EPSILON) * 100) / 100
        }

        return (
            <div>
                <h3><center><u>Check Roll Weighment Summary Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division === undefined ? "All Divisions" : searchData.division}</div>
                    <div className="col"><b>Feild: </b> {searchData.feild === undefined ? "All Feilds" : searchData.feild}</div>
                    <div className="col"><b>Job Type: </b> {searchData.pluckingType === undefined ? "All Jobs" : searchData.pluckingType}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="card">
                    <div className="card-header"><h6>Weigh Details</h6></div>
                    <div className="card-body">
                        <p className="d-inline pr-3"><b>Net Amount : </b> {details.gross} Kg</p>
                        <p className="d-inline pr-3"><b>Checkroll Amount : </b>{details.net} Kg</p>
                        <p className="d-inline pr-3"><b>Actual Amount : </b>{details.total} Kg</p>
                        <div className="d-inline"><b>Total {details.gainloss < 0 ? " Loss" : " Gain"} : </b><div className={details.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}
                            style={{ fontSize: "14px" }}>{Math.abs(details.gainloss)} Kg</div></div>
                        <br></br>
                        {detailDeductions.map((d, i) => {
                            return (
                                <p key={i} className="pt-3 d-inline pr-3"><b>{d.name} : </b>{roundNumbers(d.value)} Kg</p>
                            )
                        })}
                    </div>
                </div>
                <div className="pl-2">
                    <div>
                        <table
                            id="summaryReportPdf">
                            <thead>
                                <tr style={{ fontSize: "12px" }}>
                                    <th style={{ fontSize: "12px" }}>EPF No</th>
                                    <th style={{ fontSize: "12px" }}>Registration Number</th>
                                    <th style={{ fontSize: "12px" }}>First Name</th>
                                    <th style={{ fontSize: "12px" }}>Division</th>
                                    <th style={{ fontSize: "12px" }}>Field</th>
                                    <th style={{ fontSize: "12px" }}>Job Type</th>
                                    <th style={{ fontSize: "12px" }}>Actual (Kg)</th>
                                    {headerLables.map((data, index) => {
                                        return (
                                            <th style={{ fontSize: "12px" }} key={index}>{data}</th>
                                        );
                                    })}
                                    <th style={{ fontSize: "12px" }}>Net (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Checkroll (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Extra (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Gain/ Loss (Kg)</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                                <TableContentForCheckrollWeighReport
                                    data={data}
                                    contentRowNames={rowNames}
                                    hasEdit={false}
                                    deductions={headerLables}
                                />
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th style={{ textAlign: "left" }} colSpan="4">Total</th>
                                    <th style={{ textAlign: "left" }}>Employee Count {employeeCount}</th>
                                    <th style={{ textAlign: "right" }}>{ }</th>
                                    <th style={{ textAlign: "right" }}>{details.total}</th>
                                    {headerLables.map((d, i) => {
                                        var matchingRecord = detailDeductions.find(x => x.name === d);
                                        if (matchingRecord) {
                                            return (
                                                <th key={i} style={{ textAlign: "right" }}>{matchingRecord.value.toFixed(2)}</th>
                                            )
                                        } else {
                                            return (
                                                <th key={i} style={{ textAlign: "right" }}>0.00</th>
                                            )
                                        }

                                    })}
                                    <th style={{ textAlign: "right" }}>{details.gross}</th>
                                    <th style={{ textAlign: "right" }}>{details.net}</th>
                                    <th style={{ textAlign: "right" }}>{details.extraKg}</th>
                                    <th style={{ textAlign: "center" }}>
                                        <span className={details.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}>
                                            {details.gainloss < 0 ? "Loss " : "Gain "}
                                            {Math.abs(details.gainloss)}
                                        </span>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

            </div>
        );
    }
}